import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import AuthContainer from 'containers/AuthContainer';
import { LoginScreen, ForgotPasswordScreen } from 'screens/Auth';

const AuthRouter = () => (
  <AuthContainer>
    <Router>
      <Switch>
        <Route path="/login" component={LoginScreen} />
        <Route path="/forgotpassword" component={ForgotPasswordScreen} />
        <Route exact path="" component={LoginScreen} />
      </Switch>
    </Router>
  </AuthContainer>
);

export default AuthRouter;
